export default "__VITE_ASSET__BcIA5fhr__";